import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router'
import { hasPermission } from '#/user/me'
import { accountsQueryOptions } from '#/api/accounts'
import { workspacesQueryOptions } from '#/api/workspaces'

export const Route = createFileRoute('/_authed/')({
  beforeLoad: async ({ context }) => {
    if (hasPermission(context.me, 'annwn:accounts:manage')) {
      throw redirect({ to: '/accounts' })
    }

    // `_authed`'s beforeLoad already prefetches + error-guards accountsQueryOptions,
    // so in practice only the workspaces fetch below can fail here. Either way, a
    // query failure falls through to the account picker (never a blank `/`).
    try {
      const accounts =
        await context.queryClient.ensureQueryData(accountsQueryOptions)
      const activeAccounts = accounts.filter((a) => a.status === 'active')
      if (activeAccounts.length === 1) {
        const accountId = activeAccounts[0]!.uuid
        const workspaces = await context.queryClient.ensureQueryData(
          workspacesQueryOptions(accountId),
        )
        const activeWorkspaces = workspaces.filter((w) => w.status === 'active')
        if (activeWorkspaces.length === 1) {
          throw redirect({
            to: '/accounts/$accountId/workspaces/$workspaceId',
            params: { accountId, workspaceId: activeWorkspaces[0]!.uuid },
          })
        }
        throw redirect({
          to: '/accounts/$accountId/workspaces',
          params: { accountId },
        })
      }
    } catch (err) {
      if (isRedirect(err)) throw err // a real redirect target — let it through
      // query failure: fall through to the account picker below
    }

    throw redirect({ to: '/accounts' })
  },
})
